import {NotificationComponentObject} from "../../classes/notification-component-object";

export const NOTIFICATIONS_STATE_NAME = 'notification-center';

export interface NotificationsState {
  notifications: NotificationComponentObject[];
  loading: boolean;
  loaded: boolean;
}
